export default {
      id: "backspace-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#backspace",
      toString: function () {
        return this.url;
      }
    }